//const PARTNER_BASE = "http://localhost:8080/v1/r2r/partner";
const PARTNER_BASE = "https://ready2rental.onrender.com/v1/r2r/partner";
export async function updatePartnerProfile(dto,idToken) {
  const res = await fetch(`${PARTNER_BASE}/profile`, {
    method: "PUT",
    headers: { "Content-Type": "application/json",Authorization: "Bearer " + idToken, },
    body: JSON.stringify(dto),
  });
  if(!res.ok) throw new Error("Profile update failed");
  return res.json();
}

export async function getPartnerProfile(partnerId) {
  const res = await fetch(`${PARTNER_BASE}/profile/${partnerId}`);
  if(!res.ok) throw new Error("Fetch profile failed");
  return res.json();
}
